module.exports = {"loader":{"start":"0%","progress":"%"}}


//////////////////
// WEBPACK FOOTER
// ./src/scripts/data/app-copy.json
// module id = 12
// module chunks = 0